/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardComponent {

    @Input() title: string;
    @Input() listGroups: string[];
    @Input() baseCypressTag = 'card';

    itemCypressTag(index: number): string {
        return `${this.baseCypressTag}-list-group-item-${index ?? 0}`;
    }
}
